module.exports = __webpack_public_path__ + "img/13_34.7f2570b6.png";